<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="医生认证"></el-page-header>
    <ul class="info">
        <li><span class="span-key">医生姓名：</span>{{info.doctorName}}</li>
        <li><span class="span-key">医生性别：</span>{{info.doctorSex == '0'?'女':'男'}}</li>
        <li><span class="span-key">医生电话：</span>{{info.doctorPhonNo}}</li>
        <li><span class="span-key">身份证号：</span>{{info.idNo}}</li>
        <li><span class="span-key">行医资格证编号：</span>{{info.doctorCertNo}}</li>
    </ul>
    <div class="doctor-cert">
      <span>行医资格证：</span>
      <img :src="info.doctorCertImageUrl" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        info: {}
      }
    },
    created() {
      this.info = JSON.parse(this.$route.query.info)
    },
    methods:{
      goBack(){
          if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
              this.$router.go(-1)
          }else{
              this.$router.replace('/')
          }
      },
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    }
  }
</script>

<style scoped>
  .container{
      width: 1000px;
      height: auto;
      display: flex;
      margin: 0px auto;
      flex-direction: column;
      align-items: center;
      overflow: auto;
  }
  .page-header{
      width: 1000px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .info{
    width: 550px;
  }
  .info>li{
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
    text-align: left;
  }
  .span-key{
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    color: #333333;
    width: 140px;
    display: inline-block;
    font-weight: bold;
  }
  .doctor-cert{
    width: 550px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: auto;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .doctor-cert>span{
    font-size: 16px;
    color: #333333;
    width: 140px;
    margin-left: 20px;
    display: inline-block;
    font-weight: bold;

  }
  .doctor-cert>img{
    width: 220px;
    height: 160px;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/userInfo.vue